export default {
    data: () => ({
        stockColumns: [
            {
                label: "id",
                field: "id",
                required: true
            }, {
                label: "lending point",
                field: "description",
                sortable: true,
                required: true
            }, {
                label: "available",
                field: "stock_available_count",
                required: true
            }, /*{
                label: "reserved",
                field: "stock_reserved_count",
                required: true
            },*/ {
                label: "broken",
                field: "stock_broken_count",
                required: true
            }, {
                label: "not returned",
                field: "stock_not_returned_count",
                required: true
            }, {
                label: "in lending",
                field: "stock_in_lending_count",
                required: true
            }, {
                label: "retired",
                field: "stock_retired_count",
                required: true
            },{
                label: "picked up",
                field: "stock_picked_up_count",
                required: true
            },{
                label: "pending reception",
                field: "stock_pending_reception_count",
                required: true
            },{
                label: "no received",
                field: "stock_no_received_count",
                required: true
            },{
                label: "segmentation type",
                field: "segmentation_count",
                required: true
            },{
                label: "actions",
                field: "stock_actions",
                required: true
            },
        ]
    })
}



// WEBPACK FOOTER //
// ./resources/assets/js/pages/stockColumns.js